/* RESPONSIBLE TEAM: team-email */

import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { post } from 'embercom/lib/ajax';
import { tracked } from '@glimmer/tracking';

export const VALIMAIL_DMARC_RUA = 'mailto:dmarc_agg@vali.email';

export default class ValimailService extends Service {
  @service appService: any;
  @tracked accountSlug: string | null = null;
  @tracked valimailDmarcRua: string | null = null;

  get dmarcValue(): string {
    let baseValue = 'v=DMARC1; p=none';
    if (this.valimailDmarcRua) {
      return `${baseValue}; rua=${this.valimailDmarcRua}`;
    }
    return baseValue;
  }

  async initializeAccount(domain: string): Promise<{ success: boolean; dmarcRua?: string }> {
    try {
      let response = await post(`/ember/valimail/accounts?app_id=${this.appService.app.id}`, {
        domain,
      });

      this.accountSlug = response.account_slug;

      this.valimailDmarcRua = VALIMAIL_DMARC_RUA;

      return {
        success: true,
        dmarcRua: VALIMAIL_DMARC_RUA,
      };
    } catch (error) {
      console.error('Failed to initialize Valimail account:', error);
      return {
        success: false,
      };
    }
  }

  reset() {
    this.accountSlug = null;
    this.valimailDmarcRua = null;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'valimail-service': ValimailService;
  }
}
